import React, { useState } from "react";
import "../component/partnerHeader.css";

import { FaPlusCircle } from "react-icons/fa";

const PartnerHeader = ({ onAddPartnerClicked, onSearchPartnerEdited }) => {
  const [searchValue, setSearchValue] = useState(
    localStorage.getItem("searchValue")
  );
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
    e.preventDefault();
    if (errorMessage && e.target.value >= 3) {
      setErrorMessage("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      localStorage.setItem("searchValue", searchValue);
      e.preventDefault();
      if (searchValue.length > 2) {
        onSearchPartnerEdited(searchValue);
        setErrorMessage("");
      } else if (searchValue.length === 0) {
        onSearchPartnerEdited(searchValue);
        setErrorMessage("");
      } else {
        setErrorMessage("Pencarian membutuhkan minimal lebih dari 3 huruf");
      }
    }
  };

  return (
    <div className="partner-header-container">
      <button className="add-partner-button" onClick={onAddPartnerClicked}>
        <FaPlusCircle />
        Tambah Partner Baru
      </button>

      <div className="search-container">
        <input
          type="text"
          placeholder="Cari Partner"
          className="search-input"
          value={searchValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
        {errorMessage && <p className="error-message">{errorMessage}</p>}
      </div>
    </div>
  );
};

export default PartnerHeader;
